import { isPlatformServer } from '@angular/common';
import {
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor/auth.interceptor';
import { channelInterceptor } from './core/interceptors/channel.interceptor/channel.interceptor';
import { ChannelSettingsService } from './core/services/channel-settings.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([channelInterceptor, authInterceptor])),
    provideAppInitializer(() => {
      if (isPlatformServer(inject(PLATFORM_ID))) {
        return;
      }

      const channelSettings = inject(ChannelSettingsService);
      return firstValueFrom(channelSettings.load());
    }),
  ],
};
